import type { OrderFilters, OrderListResult } from '../../domain/entities/Order';
import type { OrderRepository } from '../../domain/repositories/OrderRepository';

export class GetOrdersUseCase {
  constructor(private readonly repository: OrderRepository) {}

  async execute(filters: OrderFilters = {}, page = 1): Promise<OrderListResult> {
    return this.repository.getOrders(filters, page);
  }
}
